import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "space-y-6 px-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-span-2 w-full" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_4 = { class: "plane-form-section pt-6" }
const _hoisted_5 = { class: "mt-6 flex flex-col gap-6" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-y-6" }
const _hoisted_7 = { class: "mt-6 flex flex-col gap-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "col-span-2 w-full" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_9 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_10 = { class: "flex capitalize mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableSchedulePlane = _resolveComponent("TableSchedulePlane")!
  const _component_CreateUpdate = _resolveComponent("CreateUpdate")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_delete_config_popup = _resolveComponent("delete-config-popup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: "Detail Konfigurasi",
      loading: _ctx.isLoading,
      error: !!_ctx.errorCause,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailData
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Title, { label: "Detail Konfigurasi" }),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Title, {
              label: "Rute Awal",
              class: "col-span-2 mt-2"
            }),
            _createVNode(_component_DataWrapper, {
              label: "Kota Asal",
              value: _ctx.detailCargoConfiguration.originCity.codeNameCity
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              label: "Kota Tujuan",
              value: _ctx.detailCargoConfiguration.destinationCity.codeNameCity
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: `${!_ctx.isShowVendor ? 'col-span-2' : ''}`,
              label: "Transportasi",
              value: _ctx.detailCargoConfiguration.transportationName
            }, null, 8, ["class", "value"]),
            _withDirectives(_createVNode(_component_DataWrapper, {
              label: "Nama Vendor",
              value: _ctx.detailCargoConfiguration.vendor.name
            }, null, 8, ["value"]), [
              [_vShow, false]
            ])
          ]),
          _hoisted_3,
          (
            _ctx.isShowPlaneForm && _ctx.detailCargoConfiguration.schedulePlane.length
          )
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "col-span-2 w-full"
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_Title, { label: "Jadwal Penerbangan" })
                ]),
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode(_component_TableSchedulePlane, {
                      dataSchedule: _ctx.detailCargoConfiguration.schedulePlane
                    }, null, 8, ["dataSchedule"])
                  ]),
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_DataWrapper, {
                      label: "Klien Induk",
                      value: _ctx.detailCargoConfiguration.clientParentName
                    }, null, 8, ["value"]),
                    _createVNode(_component_DataWrapper, {
                      label: "Klien Cabang",
                      value: _ctx.clientBranch
                    }, null, 8, ["value"])
                  ])
                ]),
                _: 1
              }))
            : (_ctx.activeCutOffTime.length)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  class: "col-span-2 w-full"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_Title, {
                      label: "Waktu Cut Off",
                      class: "mb-4"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_6, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeCutOffTime, (cutOff, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          _createVNode(_component_DataWrapper, {
                            label: `Cycle ${index + 1}`,
                            value: _ctx.formatTime(cutOff.ctTime)
                          }, null, 8, ["label", "value"])
                        ]))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_DataWrapper, {
                        label: "Klien Induk",
                        value: _ctx.detailCargoConfiguration.clientParentName
                      }, null, 8, ["value"]),
                      _createVNode(_component_DataWrapper, {
                        label: "Klien Cabang",
                        value: _ctx.clientBranch
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _hoisted_8,
          _createVNode(_component_DataWrapper, null, {
            label: _withCtx(() => [
              _createVNode(_component_Title, {
                label: "Detail Produk",
                class: "mb-6"
              })
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_DataWrapper, {
                  label: "Tipe Komoditi",
                  value: _ctx.detailCargoConfiguration.joinCommoditiesName()
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  label: "Jenis Pengiriman",
                  value: _ctx.detailCargoConfiguration.joinProducts()
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  class: `${!_ctx.isShowPlaneForm ? 'col-span-2' : ''}`,
                  label: "Maksimum Koli",
                  value: _ctx.detailCargoConfiguration.maximumPieces
                }, null, 8, ["class", "value"]),
                (_ctx.isShowPlaneForm)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      label: "Tipe Produk Kargo",
                      value: _ctx.cargoProductValue
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_DataWrapper, {
                  label: "Minimum berat(kg)",
                  value: _ctx.detailCargoConfiguration.minimumWeight
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  label: "Maksimum berat(kg)",
                  value: _ctx.detailCargoConfiguration.maximumWeight
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  label: "Minimum Volume(kg)",
                  value: _ctx.detailCargoConfiguration.minimumVolume
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  label: "Maksimum Volume(kg)",
                  value: _ctx.detailCargoConfiguration.maximumVolume
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: "Status"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", {
                class: _ctx.onChipStatus(_ctx.detailCargoConfiguration.status)
              }, _toDisplayString(_ctx.detailCargoConfiguration.status ? "Aktif" : "Tidak Aktif"), 3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_CreateUpdate, {
          "updated-by": _ctx.detailCargoConfiguration.updatedBy,
          "updated-at": _ctx.formatDate(_ctx.detailCargoConfiguration.updatedAt),
          "created-by": _ctx.detailCargoConfiguration.createdBy,
          "created-at": _ctx.formatDate(_ctx.detailCargoConfiguration.createdAt)
        }, null, 8, ["updated-by", "updated-at", "created-by", "created-at"]),
        (_ctx.isEditAble)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              title: "Ubah Konfigurasi",
              onClick: _ctx.goToEdit,
              "custom-class": "w-44",
              textColor: 
          _ctx.detailCargoConfiguration.status ? 'red-lp-300' : 'gray-lp-300'
        ,
              color: _ctx.detailCargoConfiguration.status ? 'red-lp-300' : 'gray-lp-300',
              iconLeft: 
          _ctx.detailCargoConfiguration.status ? 'pencil-alt' : 'pencil-alt-grey'
        ,
              outline: ""
            }, null, 8, ["onClick", "textColor", "color", "iconLeft"]))
          : _createCommentVNode("", true),
        (_ctx.isEditAble && !_ctx.detailCargoConfiguration.status)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 1,
              title: "Hapus Konfigurasi",
              onClick: _ctx.deleteConfig,
              "custom-class": "w-44",
              textColor: "red-lp-300",
              iconLeft: "trash-red",
              outline: ""
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain"]),
    (_ctx.deleteConfigModal)
      ? (_openBlock(), _createBlock(_component_delete_config_popup, _mergeProps({
          key: 0,
          modelValue: _ctx.deleteConfigModal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteConfigModal = $event))
        }, _ctx.configSelected), null, 16, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}